import { getData } from "../core/preference";
import React, { Component } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

const getToken = async (): Promise<string | null> => await getData('token');

type PrivateRouteProps = RouteProps & {
  component: React.ComponentType<any>;
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const token:any = getToken();
  console.log("TOken",token)
  // getData('token').then((res)=>{
  //   token = res
  // })
  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
